<div class="loader-container" *ngIf="showLoader$ | async">
  <div class="loader-and-label-container">
    <div class="loader"></div>
    <div class="label">{{ loaderText$ | async }}</div>
    <div class="cancel" (click)="hideLoader()">Cancelar</div>
  </div>
</div>
